import React from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import useStyles from "@hooks/useStyles";
import Header from "@components/Main/Shared/Header";
import Footer from "@components/Main/Shared/Footer";
import useConstants from "@hooks/useConstants";

import CostsHero from "./CostsHero";
import CostsBanner from "./CostsBanner";
import CostsPopular from "./CostsPopular";
import CostsTutors from "./CostsTutors";
import CostsList from "./CostsList";

const Costs = () => {
	const classes = useStyles("Costs");

	const { showHero, showPopular, showTutors } = useConstants("CostsViewModel");

	return (
		<React.Fragment>
			<Header />

			{showHero ? <CostsHero /> : <CostsBanner />}
			{showTutors && <CostsTutors />}
			<CostsList />
			{showPopular && <CostsPopular />}

			<Footer />
		</React.Fragment>
	);
};

export default Costs;
export const loader = (route) =>
	loadable(() => import("./Costs.component"), { ssr: !!route.ssr });
